import script from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=6cc13cd0&scoped=true&lang=css&external"
import "./TaskDetailRightSide.vue?vue&type=style&index=1&id=6cc13cd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc13cd0"]])

export default __exports__